"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _Translations = require("react-platform-components/dist/Translations");
var _reactRedux = require("react-redux");
var _CreateBankAccountForm = _interopRequireDefault(require("./CreateBankAccountForm"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = (0, _BaseInjectors.injectToBaseCreationDialog)(_.flowRight((0, _reactRedux.connect)()), {
  createForm: _CreateBankAccountForm.default,
  title: "Ajouter un compte bancaire___",
  // Override handleSubmit of BaseCreationDialog
  handleSubmit: function handleSubmit(values) {
    this.dispatch({
      type: 'CREATE_MANGOPAY_BANK_ACCOUNT',
      data: values
    });
    this.close();
  }
});
exports.default = _default;